import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from 'dashboard/helper/URLHelper';
import WorkflowsShell from './WorkflowsShell.vue';
import Automation from '../settings/automation/Index.vue';
import AutomationEditor from '../settings/automation/AutomationEditor.vue';

const workflowsMeta = {
  featureFlag: FEATURE_FLAGS.AUTOMATIONS,
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/workflows'),
      component: WorkflowsShell,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'automation_list',
            params: { accountId: to.params.accountId },
          }),
        },
        {
          path: 'list',
          name: 'automation_list',
          component: Automation,
          meta: workflowsMeta,
        },
        {
          path: 'builder/new',
          name: 'automation_editor_new',
          component: AutomationEditor,
          meta: workflowsMeta,
        },
        {
          path: 'builder/:automationId',
          name: 'automation_editor_edit',
          component: AutomationEditor,
          meta: workflowsMeta,
        },
      ],
    },
  ],
};
